import { useQuery } from '@tanstack/react-query'
import { getApiClient } from '@/lib/api'
import type { CatalogSummaryResponse } from '@/types/api'

/**
 * 掌握サマリーを取得するフック（CL-05）。
 * Tier A object 別の掌握/未掌握・全体掌握率・Tier B/C 状態（集計値のみ）を返す。
 */
export function useCatalogSummary(sfOrgId?: string) {
  return useQuery<CatalogSummaryResponse>({
    queryKey: ['catalog', 'summary', sfOrgId ?? null],
    queryFn: () => getApiClient().getCatalogSummary(sfOrgId),
    // 5分ごとに更新
    staleTime: 5 * 60 * 1000,
  })
}
